import React, { Component } from 'react';
import axios from 'axios';
import MostrarInfo from './btn_informacion';
import {Modal, Button} from "react-bootstrap";
import ModalAdicional from './modalAdicional';
import ModalBeneficiario from './modalBeneficiario'

let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/get_ventas_mac';
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';


export default class MostrarDetalle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obserbaciones_contacto: [],
            contador: 0,
            id_interaccion: [],
            id_contacto: this.props.id_contacto,
            id_campana: this.props.id_campana,
            id_contacto_genesys: this.props.id_contacto_genesys,
            fono: this.props.fono,
            cola: this.props.cola,
            id_ejecutivo: this.props.id_ejecutivo,
        };

        this.ocultarModal = this.ocultarModal.bind(this)
        this.mostrarInfo = this.mostrarInfo.bind(this)
        this.mostrarAdi = this.mostrarAdi.bind(this)
        this.mostrarBenef = this.mostrarBenef.bind(this)
    }

    ocultarModal(){
        this.setState({
            showInfo: false,
            showBenef: false,
            showAdi: false
        })
    }

    
    mostrarAdi(e){
        this.setState({
            showAdi : true,
            contador: this.state.contador+1,
            id_interaccion: e.target.id
        })
        
        console.log(e.target)
    }

    mostrarBenef(e){
        this.setState({
            showBenef : true,
            contador: this.state.contador+1,
            id_interaccion: e.target.id
        })
        console.log(e.target)
    }

    mostrarInfo(e){
        console.log(e.target.id)
        this.setState({
            showInfo : true,
            id_interaccion: e.target.id
        })
        console.log(e)
    }

    fetchData(){
        //console.log('llamo servicio mostrar obserbacion')
        //console.log('valido dato:  ' +this.props.data)
         const body = JSON.stringify({
             con_id: this.props.data
         })
        //console.log(body)
        axios.post(baseUrl,body)
             .then(response => {
                //  console.log('exito get_evaluadores: ' + JSON.stringify(response.data));
                //  console.log('actualiza')
                 this.setState({obserbaciones_contacto:response.data});
                //  console.log(response)
             })
             .catch(response => {
                 console.log(response + ' error get_evaluadores')
             }
        )
    }

    componentDidUpdate(){
        //  console.log('contador enviado '+this.props.contador)
        //  console.log('contador actual '+this.state.contador)
         if (this.state.contador !== this.props.contador) {
            //  console.log('es distinto al numero anterio '+ this.state.contador)
             setTimeout(() => {
                 this.fetchData(this.state.obserbaciones_contacto);
               }, 800);
            this.setState({contador: this.props.contador})
         }
    }

    async componentDidMount() {
        
        //console.log('llamo servicio mostrar obserbacion')
        //console.log('valido dato:  ' +this.props.data)
        const body = JSON.stringify({
            con_id: this.props.data
        })
        //console.log(body)
        axios.post(baseUrl,body)
            .then(response => {
                //console.log('exito get_evaluadores: ' + JSON.stringify(response.data));
                setTimeout(() => {
                    this.fetchData(this.state.obserbaciones_contacto);
                  }, 800);
                //this.setState({obserbaciones_contacto:response.data});
                //console.log(response)
            })
            .catch(response => {
                console.log(response + ' error get_evaluadores')
            }
        )
        
    }
    render() {
        const { obserbaciones_contacto } = this.state;
        //console.log('length evaluadores: '+evaluadores.length)
        let contactoList = obserbaciones_contacto.length > 0
            && obserbaciones_contacto.map((item, i) => {
                return (
                    <tr key={i++}>
                        <td>{i+1}</td>
                        <td><Button size='sm' variant="primary" id={item.id_interaccion} type="button" onClick={this.mostrarInfo}>Informacion</Button></td>
                        <td><Button size='sm' variant="primary" id={item.id_interaccion} type="button" onClick={this.mostrarAdi}>Adicional</Button></td>
                        {/* <td><Button size='sm' variant="primary" id={item.id_interaccion} type="button" onClick={this.mostrarBenef}>Beneficiario</Button></td> */}
                        <td>{item.rut}</td>
                        <td>{item.nombre+' '+item.appaterno+' '+item.apmaterno}</td>
                        <td>{item.fechanacimiento}</td>
                        <td>{item.pro_valu_plan}</td>
                        <td>{item.desc_plan}</td>
                    </tr>
                )
            }, this);
        return (
            <tbody>
                {contactoList}
                <Modal size="lg" dialogClassName="modal-90w"
                 show={this.state.showInfo}
                 onHide={this.ocultarModal}
                 backdrop="static"
                 keyboard={false}>
                    <MostrarInfo id_gestion={this.state.id_interaccion}/>
                </Modal>
                <Modal size="lg" dialogClassName="modal-90w"
                 show={this.state.showAdi}
                 onHide={this.ocultarModal}
                 backdrop="static"
                 keyboard={false}>
                    <ModalAdicional
                    handlePadre={this.handlePadre}
                    id_gestion={this.state.id_interaccion}
                    id_contacto={this.state.id_contacto}
                    id_campana={this.state.id_campana}
                    id_contacto_genesys={this.state.id_contacto_genesys}
                    fono={this.state.fono}
                    cola={this.state.cola}
                    id_ejecutivo={this.state.id_ejecutivo}>
                    </ModalAdicional>
                </Modal>
                <Modal size="lg" dialogClassName="modal-90w"
                 show={this.state.showBenef}
                 onHide={this.ocultarModal}
                 backdrop="static"
                 keyboard={false}>
                    <ModalBeneficiario
                    handlePadre={this.handlePadre}
                    id_gestion={this.state.id_interaccion}
                    id_contacto={this.state.id_contacto}
                    id_campana={this.state.id_campana}
                    id_contacto_genesys={this.state.id_contacto_genesys}
                    fono={this.state.fono}
                    cola={this.state.cola}
                    id_ejecutivo={this.state.id_ejecutivo}>
                    </ModalBeneficiario>
                </Modal>
            </tbody>
        );
    }

}